var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "properties-field",
      style: _vm.isReduceBlur ? "background-color: rgba(255,255,255,0.9);" : "",
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "wrap-properties" }, [
        _c("div", { staticClass: "properties-field-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: {
                click: function($event) {
                  _vm.submitForm(true)
                }
              }
            },
            [_vm._v("\n        ×\n      ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "properties-field-content properties-field-content-config"
          },
          [
            _c(
              "div",
              { staticClass: "section-field input-field" },
              [
                _c(
                  "b-form",
                  { class: { "error-input": _vm.$v.dataSetup.key.$error } },
                  [
                    _c("label", [_vm._v(" Key ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: {
                        disabled: _vm.isDefault(_vm.dataSetup.key),
                        placeholder: "Enter block key"
                      },
                      model: {
                        value: _vm.dataSetup.key,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "key", $$v)
                        },
                        expression: "dataSetup.key"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form",
                  { class: { "error-input": _vm.$v.dataSetup.name.$error } },
                  [
                    _c("label", [_vm._v(" Name ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: { placeholder: "Enter block name" },
                      model: {
                        value: _vm.dataSetup.name,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "name", $$v)
                        },
                        expression: "dataSetup.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form",
                  { class: { "error-input": _vm.$v.dataSetup.color.$error } },
                  [
                    _c("j-color-picker", {
                      attrs: {
                        color: _vm.dataSetup.color,
                        label: "Color",
                        picker: "chrome"
                      },
                      model: {
                        value: _vm.dataSetup.color,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "color", $$v)
                        },
                        expression: "dataSetup.color"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Configuration")
              ]),
              _vm._v(" "),
              _vm.isWorkflow
                ? _c(
                    "div",
                    {
                      staticClass: "configuration-section",
                      class: { "error-input": _vm.$v.dataSetup.type.$error }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          class: { "error-input": _vm.$v.dataSetup.type.$error }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "wrap-type" },
                            _vm._l(_vm.blockTypes, function(block) {
                              return _c(
                                "div",
                                {
                                  key: block.type,
                                  staticClass: "block-type",
                                  class: {
                                    "type-active":
                                      _vm.dataSetup.type ===
                                      block.type + "_block"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.dataSetup.type = block.type + "_block"
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/form-ui/summary-block/" +
                                        block.type +
                                        "-block.svg"),
                                      alt: block.type + "-block"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(block.text) +
                                      " Block\n              "
                                  )
                                ]
                              )
                            })
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isWorkflow && _vm.isDefault(_vm.dataSetup.key)
                ? _c("div", { staticClass: "configuration-section" }, [
                    _c(
                      "div",
                      { staticClass: "configuration-toggle-in-title" },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("j-switch", {
                          model: {
                            value: _vm.dataSetup.is_hidden,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "is_hidden", $$v)
                            },
                            expression: "dataSetup.is_hidden"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isWorkflow ||
              (_vm.isWorkflow && !_vm.isDefault(_vm.dataSetup.key))
                ? _c("div", { staticClass: "configuration-section" }, [
                    _c(
                      "div",
                      { staticClass: "configuration-toggle-in-title" },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c("j-switch", {
                          model: {
                            value: _vm.setFilter,
                            callback: function($$v) {
                              _vm.setFilter = $$v
                            },
                            expression: "setFilter"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.setFilter
                      ? _c(
                          "div",
                          { staticClass: "mt-4" },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(4),
                                _vm._v(" "),
                                _c("div", { staticClass: "filter-option" }, [
                                  _c(
                                    "div",
                                    { staticClass: "filter-selected" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.dataSetup.filterOperator)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-chevron-down",
                                    on: {
                                      click: function($event) {
                                        _vm.showFilterOptions = true
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.showFilterOptions
                                    ? _c(
                                        "div",
                                        { staticClass: "filter-options" },
                                        [
                                          _c("p", [_vm._v("Operator")]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-around"
                                            },
                                            _vm._l(
                                              _vm.filterOperatorOptions,
                                              function(operator) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: operator.id,
                                                    staticClass:
                                                      "operator-option",
                                                    class: {
                                                      "operator-selected":
                                                        operator.id ===
                                                        _vm.dataSetup
                                                          .filterOperator
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.closeFilterOptions(
                                                          operator.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(operator.name) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h3",
                              { staticClass: "configuration-section-subtitle" },
                              [_vm._v("By Value")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dataSetup.filter, function(data, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "div-filter" },
                                [
                                  _c("div", { staticClass: "header-filter" }, [
                                    _c("div", { staticClass: "index" }, [
                                      _vm._v(_vm._s(index + 1))
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-trash",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteFilter(index)
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    { staticClass: "mb-2" },
                                    [
                                      _c("label", [_vm._v(" Column ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required": false,
                                          options: _vm.variableOptions,
                                          placeholder: "Select Column",
                                          "value-format": "object",
                                          label: "label"
                                        },
                                        model: {
                                          value: data.key,
                                          callback: function($$v) {
                                            _vm.$set(data, "key", $$v)
                                          },
                                          expression: "data.key"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    [
                                      _c("label", [_vm._v(" Value ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required": false,
                                          placeholder: "Input Filter Value"
                                        },
                                        model: {
                                          value: data.value,
                                          callback: function($$v) {
                                            _vm.$set(data, "value", $$v)
                                          },
                                          expression: "data.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-config",
                                on: { click: _vm.addFilter }
                              },
                              [
                                _vm._v(
                                  "\n              + Add Parameter\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "separator" }),
                            _vm._v(" "),
                            _c(
                              "h3",
                              { staticClass: "configuration-section-subtitle" },
                              [_vm._v("By Function")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "warning-function d-flex align-items-center"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/icon/warning.svg"),
                                    alt: "warning"
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(5)
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dataSetup.filter_function, function(
                              data,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index, staticClass: "div-filter" },
                                [
                                  _c("div", { staticClass: "header-filter" }, [
                                    _c("div", { staticClass: "index" }, [
                                      _vm._v(_vm._s(index + 1))
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-trash",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteFilterFunction(index)
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    { staticClass: "mb-2" },
                                    [
                                      _c("label", [_vm._v(" Column ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required": false,
                                          options: _vm.variableOptions,
                                          placeholder: "Select Column",
                                          "value-format": "object",
                                          label: "label"
                                        },
                                        model: {
                                          value: data.key,
                                          callback: function($$v) {
                                            _vm.$set(data, "key", $$v)
                                          },
                                          expression: "data.key"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    [
                                      _c("label", [_vm._v(" Function ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          options: _vm.listFunction,
                                          placeholder: "Select Function",
                                          "error-required": false,
                                          label: "name"
                                        },
                                        model: {
                                          value: data.value,
                                          callback: function($$v) {
                                            _vm.$set(data, "value", $$v)
                                          },
                                          expression: "data.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-config",
                                on: { click: _vm.addFilterFunction }
                              },
                              [
                                _vm._v(
                                  "\n              + Add Parameter\n            "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "properties-field-button",
            class: {
              "justify-content-end":
                (!_vm.fieldDetail && !_vm.isWorkflow) ||
                (_vm.fieldDetail &&
                  _vm.isWorkflow &&
                  _vm.isDefault(_vm.dataSetup.key)) ||
                (!_vm.fieldDetail &&
                  _vm.isWorkflow &&
                  !_vm.isDefault(_vm.dataSetup.key))
            }
          },
          [
            (_vm.fieldDetail && !_vm.isWorkflow) ||
            (_vm.fieldDetail &&
              _vm.isWorkflow &&
              !_vm.isDefault(_vm.dataSetup.key))
              ? _c(
                  "button",
                  {
                    staticClass: "button-border",
                    on: { click: _vm.deleteConfiguration }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete\n      ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  on: {
                    click: function($event) {
                      _vm.submitForm(true)
                    }
                  }
                },
                [_vm._v("\n          Close\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-blue",
                  on: {
                    click: function($event) {
                      _vm.submitForm(false)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.fieldDetail ? "Update" : "Add") +
                      "\n        "
                  )
                ]
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n        Properties\n        "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Summary Block")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "configuration-toggle-in-title" }, [
      _c("div", { staticClass: "wrap-title" }, [
        _c("h4", { staticClass: "configuration-section-title" }, [
          _vm._v("Block Type")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Hidden")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title mb-0" }, [
        _vm._v("Use Filter")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Filter")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                  Filter data according to the parameters\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Information")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                  If you implement filter function on summary block, then filter function on table view will be missed for filltering\n                "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4764f703", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4764f703","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/SummaryBlockConfiguration.vue
// module id = null
// module chunks = 